import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  href?: string;
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
  showIcon?: boolean;
}
export const Button: React.FC<ButtonProps> = ({
  children,
  href,
  variant = 'primary',
  fullWidth = false,
  showIcon = true,
  className = '',
  ...props
}) => {
  const baseStyles = 'relative inline-flex items-center justify-center font-bold rounded-lg transition-all duration-300 overflow-hidden group';
  const variants = {
    primary: 'bg-cta hover:bg-cta-hover text-night-900 animate-cta-pulse hover:shadow-[0_0_40px_rgba(245,158,11,0.6)]',
    secondary: 'bg-accent-blue hover:bg-blue-600 text-white animate-cta-pulse hover:shadow-[0_0_30px_rgba(59,130,246,0.5)]',
    outline: 'border-2 border-night-700 hover:border-accent-blue text-white bg-night-800/50 hover:bg-night-800 animate-cta-pulse'
  };
  const sizes = 'px-8 py-4 text-lg md:text-xl';
  const widthClass = fullWidth ? 'w-full' : '';
  const content = <>
      <span className="relative z-10 flex items-center gap-2" data-id="element-432">
        {children}
        {showIcon && <ChevronRight className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-433" />}
      </span>
      {/* Shine effect */}
      <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent group-hover:animate-[shine_1.5s_ease-in-out]" data-id="element-434" />
    </>;
  const handleClick = () => {
    if (href) {
      window.location.href = href;
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`${baseStyles} ${variants[variant]} ${sizes} ${widthClass} ${className}`} {...props} data-id="element-435">
      {content}
    </motion.button>;
};